import { BASE_API } from '../const/app';
import { useDeviceStore } from '../stores/DeviceStore';
import { useSystemStore } from '../stores/SystemStore';
import { downloadFile } from '../utils/file';
import { mobileEvent } from '../utils/mobile';

export const useDownloadFile = () => {
	const token = useSystemStore(s => s.token);
	const isMobileApp = useDeviceStore(s => s.isMobileApp);

	return async (fileUrl: string, fileName: string) => {
		let headers;
		if (fileUrl.startsWith(BASE_API)) {
			headers = { authorization: token ?? 'error' };
		}

		if (isMobileApp) {
			await mobileEvent({
				type: 'DownloadFile',
				url: fileUrl,
				fileName,
				headers,
			});
		} else {
			await downloadFile(fileUrl, fileName, headers);
		}
	};
};
